export const statusData = {
  0: '进行中',
  2: '已完成'
}